import Get from 'app/utils/Get';
import {getLinkPath} from 'app/utils/link_helper';
import {FaqStore} from 'app/store/FaqStore';
import {RecipeStore} from 'app/store/artifact/recipe';
import {StreamStore} from 'app/store/stream_store';
import {StoriesStore, StoriesFormInterface} from 'app/store/StoriesStore';
import StreamInterface from 'app/interfaces/StreamInterface';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import {ShopItemsGamesInterface} from 'app/store/ShopStore';
import GameInterface from 'app/interfaces/GameInterface';
import {GamesStore} from 'app/store/GamesStore';
import {GiveawayStore} from 'app/store/GiveawayStore';
import GiveawayInterface from 'app/interfaces/GiveawayInterface';
import {PromoActionStore, PromoActionsInterface} from 'app/store/PromoActionStore';
import {SiteNotificationStore} from 'app/store/SiteNotificationStore';
import SiteNotificationInterface from 'app/interfaces/SiteNotificationInterface';
import SurveyInterface from 'app/interfaces/SurveyInterface';
import {ActiveSurveyStore} from 'app/store/ActiveSurveyStore';

interface InitialDataResponse {
    promo_actions: PromoActionsInterface
    giveaway: GiveawayInterface
    games: GameInterface[]
    streams: {
        streams: StreamInterface[];
        streams_by_games: StreamInterface[];
    };
    stories: StoriesFormInterface
    hidden_temple_news: ArticleInterface[];
    lootboxes_data: {
        lootboxes: ShopItemsGamesInterface
    };
    site_notifications: SiteNotificationInterface[];
    current_survey: SurveyInterface
}

export class InitialDataService {
    // eslint-disable-next-line max-params
    static load(
        streamStore: StreamStore,
        storiesStore: StoriesStore,
        recipeStore: RecipeStore,
        faqStore: FaqStore,
        gamesStore: GamesStore,
        giveawayStore: GiveawayStore,
        promoActionStore: PromoActionStore,
        siteNotificationStore: SiteNotificationStore,
        activeSurveyStore: ActiveSurveyStore
    ): Promise<void> {
        return new Get({url: getLinkPath('/initial_data')})
            .execute()
            .then(response => response.json())
            .then((data: InitialDataResponse) => {
                promoActionStore.update(data.promo_actions);
                giveawayStore.init(data.giveaway);
                gamesStore.init(data.games);
                streamStore.init(data.streams.streams, data.streams.streams_by_games);
                storiesStore.init(data.stories);
                recipeStore.updateLootboxes(data.lootboxes_data.lootboxes);
                faqStore.updateHiddenTemples(data.hidden_temple_news);
                siteNotificationStore.init(data.site_notifications);
                activeSurveyStore.init(data.current_survey);
            })
            .catch(error => {
                console.error('Failed to load initial data:', error);
            });
    }
}
